import React, { useEffect, useState, useRef } from 'react';
import '../styles/startScreen.css';
import events from '../utility/trackingEvents';
import { Loader } from '../components/Loader';
import { useAppContext } from '../utility/AppProvider';
import { useNavigate } from 'react-router-dom';
import { getAnswer } from '../utility/api';
import OptionButton from '../components/OptionButton';
import BugWindow from '../components/BugWindow';


function StartScreen() {

  const { graphNames, data, setData, setOnReload, setCurrentSelectedNode, setNewData } = useAppContext();
  const [namesToShow, setNamesToShow] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [query, setQuery] = useState('');
  const [errorText, setErrorText] = useState('Press enter to create new!');
  const [showBugWindow, setShowBugWindow] = useState(false);

  const navigate = useNavigate();
  const dataUpdateFromGetAnswer = useRef(false);

  useEffect(() => {
    if (dataUpdateFromGetAnswer.current) {
      var root = data.nodes.find(n => n.group === 0);
      var newData = data.nodes.filter(n => n.parent == root.id);
      setNewData(newData);
      setCurrentSelectedNode(root.id);
      dataUpdateFromGetAnswer.current = false; // Reset the ref for future updates
    }
  }, [data]);

  function onStart(name) {
    navigate('/graph?name=' + name);
  }

  function toggleBugWindow() {
    setShowBugWindow(!showBugWindow);
  }

  function onSearch(query, callback) {
    if (graphNames.includes(query)) {
      navigate('/graph?name=' + query);
      callback(true);
      return;
    }

    getAnswer(query)
      .then(data => {
        if (data.nodes.length <= 2) {
          callback(false)
          return;
        }
        dataUpdateFromGetAnswer.current = true; // Indicate update is from getAnswer
        setData(data);
        setOnReload(true);
        setIsLoading(false);
        navigate('/graph?name=' + query);
        callback(true);
      });
  }

  useEffect(() => {
    if (graphNames.length > 0) {
      setIsLoading(false);
    }
    setNamesToShow(filterNamesByQuery(query));
  }, [graphNames]);

  useEffect(() => {
    setNamesToShow(filterNamesByQuery(query));
    setErrorText('Press enter to create new!');
  }, [query]);

  function filterNamesByQuery(query) {
    var toShow = graphNames.filter(name => name.toLowerCase().includes(query.toLowerCase()));
    toShow.sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' }));
    return toShow;
  }

  function onKeyDown(event) {
    if (event.key === 'Enter') {
      const searchTerm = event.target.value;
      setIsLoading(true);
      if (searchTerm) {
        events.searchTermEvent(searchTerm);
        onSearch(searchTerm, (didSucceed) => {
          if (!didSucceed) {
            setIsLoading(false);
            setErrorText('No valid graph found for this search term, please try another.');
            setNamesToShow([]);
            return;
          }
          setQuery('');
          setIsLoading(false);
        });
      }
    }
  }

  return (
    <div className="start-screen">
      <div className='explore-left'>
        <img src="/nodeBg4.webp" alt="nodeB" className="explore-image" />
        <div className="explore-heading-div">
          <div className='heading'>Explore</div>
        </div>
        <div className='explore-credits'>
          <a href="https://www.charutak.xyz" target="_blank" rel="noreferrer" className='credits-link'>
            <div className='credits'>Charu Tak</div>
          </a>
        </div>
        <div className='bug-button'>
          <OptionButton name="message" onClick={() => toggleBugWindow()} tooltip="" />
          {showBugWindow && <BugWindow setIsBugWindowOpen={setShowBugWindow} />}
        </div>
      </div>

      <div className='explore-right'>
        <div className='sub-heading'>
          Expand your knowledge by exploring infinite knowledge graphs on any topic.
        </div>
        <br />
        <input
          type="text"
          className='start-search-bar'
          placeholder="Enter any topic" // Match the placeholder to the image.
          onChange={(event) => setQuery(event.target.value)}
          onKeyDown={onKeyDown}
        />
        <div className='sub-heading'>
          Can't think of something?
          Explore what others are exploring:
        </div>
        {
          isLoading ? <Loader isLoading={isLoading} /> :
            namesToShow.length > 0 ? (
              <div className='grid-container'>
                {namesToShow.map((name, index) => (
                  <button className='grid-item' key={index} onClick={() => onStart(name)}>
                    <div className='grid-item-text'>
                      {name}
                    </div>
                  </button>
                ))}
              </div>
            ) : (
              <div className='explore-new'>{errorText}</div> // This line is added to display when namesToShow is empty
            )
        }
      </div>
    </div>
  );
}

export default StartScreen;
